
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import Dialog from "@/components/UI/Dialog.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import * as t from "io-ts";
import { fold } from "fp-ts/Either";

@Component({
  components: { TextInput, Dialog, DropdownInput }
})
export default class DocumentChooserCreateDialog extends Vue {
  @Prop()
  open!: boolean;

  autofocus = false;

  postTitle = "";
  postType = "";
  loading = false;

  @Watch("open")
  onOpenChange() {
    if (this.open) {
      this.postTitle = "";
      this.postType = "";

      setTimeout(() => {
        this.autofocus = true;
      }, 100);
    } else {
      this.autofocus = false;
    }
  }

  async create() {
    if (!this.postTitle || !this.postType) return;

    this.loading = true;

    const response = pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_insert_post",
        friendlyName: "Insert Post",
        dataToPost: {
          postTitle: this.postTitle,
          postType: this.postType
        },
        decoder: t.type({
          postId: t.number
        })
      }),
      fold(
        () => undefined,
        data => data
      )
    );

    this.loading = false;

    this.$emit("close");

    this.$emit("created", {
      postId: response?.postId,
      postTitle: this.postTitle,
      postType: this.postType
    });
  }

  dropdownOptions = {
    populate: {
      path: "",
      text: "",
      value: "",
      fetchDataAction: "breakdance_get_editable_post_types",
      fetchContextPath: "",
      refetchPaths: []
    }
  };
}
